export default __webpack_public_path__ + "static/pathway-7-7e10d9399a2f116816e12289a22336fc.jpg";